/// <reference path="./definitions.d.ts"/>
import {ComponentsConfigs, CoreGameConfig, IEventManagerWithAsync} from '@gongxigames/framework/core/types';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {Installer} from '@gongxigames/framework/core/installer';
// TODO: refactor slot imports
import {StateMachine} from '@gongxigames/framework/slotV2/fsm/StateMachine';
// TODO: refactor slot imports
import {StateMachineConfig} from '@gongxigames/framework/slotV2/fsm/stateMachineTypes';
import {coreStateMachineConfig} from '@gongxigames/framework/slotV2/states/coreStateMachineConfig';
import {CoreEventsMap} from '@gongxigames/framework/core/events';
import {GameConfig, WEBGL_LOST_CONTEXT_MESSAGE} from '@gongxigames/framework/slot';
import {resetStoreLogic} from '@gongxigames/framework/slot/services/logic/store';

// TODO: refactor slot imports
import {uiStateMachineConfig} from '@gongxigames/framework/slotV2/ui/states';
import {slotStore} from '@gongxigames/framework//slotV2/globals';

export type GameParameters = {
    componentsConfig: ComponentsConfigs[];
    gameConfig: CoreGameConfig;
    stateMachineConfig?: StateMachineConfig;
    environmentProperty: Record<string, any>;
};

// TODO: refactor slot imports. Maybe game should be moved to Slot...
export class Game {
    private eventManager!: IEventManagerWithAsync<CoreEventsMap>;
    private readonly installer: Installer;

    private stateMachineGame = new StateMachine();
    private stateMachineUi = new StateMachine();

    constructor(private parameters: GameParameters) {
        slotStore.slot_isGameStateMachineActive.value = !!parameters.stateMachineConfig;
        slotStore.isV2SafeZoneSystemActive.value = !!parameters.stateMachineConfig;
        slotStore.slot_gameProvider.value = (parameters.gameConfig as GameConfig).gameProvider ?? 'ruby';
        this.installer = new Installer(parameters.componentsConfig);

        this.init();
    }

    public static run(parameters: GameParameters): Game {
        return new Game(parameters);
    }

    private async init(): Promise<void> {
        this.installer.dependencyInjector.bindConstant(CoreDI.GameConfig, this.parameters.gameConfig);
        this.installer.dependencyInjector.bindConstant(CoreDI.EnvironmentProperty, this.parameters.environmentProperty);
        this.installer.dependencyInjector.bindConstant(CoreDI.Installer, this.installer);

        await this.installer.installServices();

        this.setupEvents();
        this.runStateMachine();
    }

    private setupEvents(): void {
        this.eventManager = this.installer.getComponent<IEventManagerWithAsync>(CoreDI.IEventManagerWithAsync);
        this.eventManager.on('General.Game.SOFT_RELOAD', this.softReload.bind(this), this);
        this.eventManager.on('General.System.WEBGL_CONTEXT_LOST', this.onWEBGLContextLost.bind(this), this);
    }

    private runStateMachine(): void {
        const gameStateMachineConfig = {...coreStateMachineConfig, ...this.parameters.stateMachineConfig};

        this.stateMachineGame.runStateMachine(gameStateMachineConfig);

        if (this.parameters.stateMachineConfig) {
            this.stateMachineUi.runStateMachine(uiStateMachineConfig);
        }
    }

    public async destroy(): Promise<void> {
        await this.installer.destroyAllComponents();
    }

    public async softReload(): Promise<void> {
        await this.destroy();
        resetStoreLogic();
        await this.init();
    }

    private onWEBGLContextLost(): void {
        this.eventManager.emit('General.Message.SHOW', WEBGL_LOST_CONTEXT_MESSAGE);
    }
}
